import { useMemo } from "react"
import type { ClientGroup } from "@stockline/shared/types/crm/client-group"
import { CLIENT_GROUP_TABLE } from "../../../lib/offline/resources/crm/client-group/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

export interface UseClientGroupsFilter {
  includeDeleted?: boolean
}

/**
 * Reactive list of every client group for the current company. Backed by the
 * offline-first `client-groups` Dexie resource. Combine with
 * `partner.clientGroupIds` at render time to surface group badges/colors.
 */
export function useClientGroups(filter?: UseClientGroupsFilter): ClientGroup[] {
  const { reactive } = useAISync()
  const rows = reactive.useQuery<ClientGroup>(CLIENT_GROUP_TABLE, {
    orderBy: "-updatedAt",
  })
  const includeDeleted = filter?.includeDeleted
  return useMemo(
    () => (includeDeleted ? rows : rows.filter((r) => !r.deletedAt)),
    [rows, includeDeleted]
  )
}
